import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Text, TextTag, TextVariant } from '@enbw/ui-react'
import styles from './styles.module.scss'
import { ContractsSearchImage } from '@/components/ContractsSearchImage'

export const InitialState: FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.emptyState}>
      <ContractsSearchImage />
      <Text variant={TextVariant.BodyStandard} tag={TextTag.P}>
        {t('contracts.initialState')}
      </Text>
    </div>
  )
}
